import {all, fork} from "redux-saga/effects";
import {put, select, takeEvery} from "@redux-saga/core/effects";
import {
    deleteElement,
    deleteElementError,
    deleteElementSuccess,
    getAllElement,
    getAllElementError,
    getAllElementErrorUserNotPageable,
    GetAllElementPayloadUser,
    getAllElementSuccess,
    getAllElementSuccessUserNotPageable,
    getAllElementUserNotPageable,
    saveElement,
    saveElementError,
    saveElementSuccess,
    updateElement,
    updateElementError,
    updateElementSuccess,
    UserElement
} from "../reducers/User/UserReducer";
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch";
import apiPaths from "../config/apiPaths";
import {PayloadAction} from "@reduxjs/toolkit";
import {openSnackbar} from "../reducers/snackbar/snackbarReducer";

interface UserFilter {
    username: string | null,
    businessName: string | null
}


function* getAllElementSaga() {
    yield takeEvery(getAllElement.type, function* (action: PayloadAction<GetAllElementPayloadUser>) {

        if (!action.payload || !action.payload.pageableDto) {
            console.error("Invalid payload or pageableDto is undefined!");
            yield put({type: getAllElementError.type});
            return;
        }

        const {pageableDto} = action.payload;

        try {

            let response: CustomFetchResponse
            let filters: UserFilter = {
                username: action.payload.filters?.find(filter => filter.id === "username")?.value as string ?? "",
                businessName: action.payload.filters?.find(filter => filter.id === "tenantId_businessName")?.value as string ?? ""
            }

            let requestPayload = {
                ...pageableDto,
                filters: filters
            }


            response = yield CustomFetch({
                method: "POST",
                url: apiPaths.filterUser, // Percorso API specifico per il filtro
                authenticated: true,
                data: requestPayload,
            })


            if (response.status === 200) {
                yield put({type: getAllElementSuccess.type, payload: response.data});

            } else {
                response = yield CustomFetch({
                    method: "POST",
                    url: apiPaths.getAllUser, // Percorso API specifico per il filtro
                    authenticated: true,
                    data: requestPayload,
                })
            }
        } catch (error) {
            console.error("Error in getAllElementSaga:", error);
            yield put({type: getAllElementError.type});
        }
    });
}

function* saveElementSaga() {
    yield takeEvery(saveElement.type, function* (action: PayloadAction<{ data: UserElement, callback: () => void }>) {

        const savePayload = {
            username: action.payload.data.username,
            email: action.payload.data.email,
            password: action.payload.data.password,
            tenantId: action.payload.data.tenantId || null,
            enabled: action.payload.data.enabled,
            roles: action.payload.data.roles,
        }


        let response: CustomFetchResponse = yield CustomFetch({
            method: "POST",
            url: apiPaths.saveUserAdminToSuperAdmin,
            authenticated: true,
            data: savePayload
        })

        if (response.status === 200) {
            yield put({type: saveElementSuccess.type, payload: response.data})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element User added successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
            yield put({
                type: getAllElement.type,
                payload: {
                    pageableDto: {
                        page: select(state => state.user.currentPage),
                        size: select(state => state.user.rowsPerPage)
                    }

                }

            },)

            action.payload.callback();

        } else {
            yield put({type: saveElementError.type})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Error insert User',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            })
        }
    })
}


function* getAllElementNotPageableSaga() {
    yield takeEvery(getAllElementUserNotPageable.type, function* (action: PayloadAction<UserElement>) {
        let response: CustomFetchResponse = yield CustomFetch({
            method: "GET",
            url: apiPaths.allUserWithoutPaginable,
            authenticated: true,
        })

        if (response.status === 200) {
            yield put({type: getAllElementSuccessUserNotPageable.type, payload: response.data})
        } else {
            yield put({type: getAllElementErrorUserNotPageable.type})
        }
    })
}

function* updateElementSaga() {
    yield takeEvery(updateElement.type, function* (action: PayloadAction<{ data: UserElement, callback: () => void }>) {

        const url = `${apiPaths.updateUser}/${action.payload.data._id}`;

        const updatePayload = {
            username: action.payload.data.username,
            email: action.payload.data.email,
            tenantId: action.payload.data.tenantId?._id || null,
            enabled: action.payload.data.enabled,
            roles: action.payload.data.roles,
        }

        let response: CustomFetchResponse = yield CustomFetch({
            method: "PUT",
            url: url,
            authenticated: true,
            // data: action.payload
            data: updatePayload
        })

        if (response.status === 200) {
            yield put({
                type: updateElementSuccess.type,
                payload: response.data
            })
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element update',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
            action.payload.callback();
        } else {
            yield put({
                type: updateElementError.type,
            })
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element not update',
                    variant: 'alert',
                    alert: {
                        color: 'warning'
                    }
                }
            })
        }
    })
}

function* deleteElementSaga() {
    yield takeEvery(deleteElement.type, function* (action: PayloadAction<{ id: string, callback: () => void }>) {


        const url = `${apiPaths.deleteUser}/${action.payload.id}`
        let response: CustomFetchResponse = yield CustomFetch({
            method: "DELETE",
            url: url,
            authenticated: true,
            data: action.payload
        })

        if (response.status === 200) {

            action.payload.callback()

            yield put({type: deleteElementSuccess.type, payload: response.data.content})
        } else {
            yield put({type: deleteElementError.type});
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Element not deleted',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            });
        }

        yield put({
            type: openSnackbar.type, payload: {
                open: true,
                message: 'Element deleted successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            }
        })
    })
}

/*
function* filterElementSaga() {
    yield takeEvery(filterElement.type, function* (action: PayloadAction<ColumnFiltersState>) {
        console.log(action.payload)
        
        const payload = action.payload;
        console.log(payload);
        
        console.log('ciao sono dentro');
      
          const url = `${apiPaths.filterUser}`

        try {
            // Prepara il payload del filtro includendo i dati richiesti
            let filters: UserFilter = {
                username: payload.find(filter => filter.id === "username")?.value as string,
                //email: payload.find(filter => filter.id === "email")?.value as string,
                //role: payload.find(filter => filter.id === "role")?.value as string,
                businessName: payload.find(filter => filter.id === "businessName")?.value as string,
            }
            console.log("Applying filter with payload:", filters);

            // Effettua una richiesta POST con i criteri di filtro
            
            const response: CustomFetchResponse = yield CustomFetch({
                method: "POST",
                url: url, // Percorso API specifico per il filtro
                authenticated: true,
                data: filters,
                 // Passa i criteri di filtro al server
            });

            if (response.status === 200) {
                let filters: UserFilter = {
                    username: payload.find(filter => filter.id === "username")?.value as string || "", // Cast a string
                    email: payload.find(filter => filter.id === "email")?.value as string || "",
                    role: payload.find(filter => filter.id === "role")?.value as string || "",
                    businessName: payload.find(filter => filter.id === "businessName")?.value as string || "",
                };
                
                console.log("qui applica il filtro:", filters);
             
            
                // Seleziona i valori attuali per la pagina corrente e le righe totali dallo stato
                const currentPage: number = yield select((state) => state.currentPage);
                const totalRows: number = yield select((state) => state.totalRows);
            
                // Verifica che la risposta contenga i dati corretti
                const filterData = response.data.content || []; // Dati filtrati
                const totalElements = response.data.totalElements && totalRows; // Numero totale di righe
                const page = response.data.currentPage ?? currentPage;
                 // Pagina corrente, usa quella di default se non presente
            
                // Aggiorna lo stato con i dati filtrati
                yield put({
                    type: filterElementSuccess.type,
                    payload: {
                        data: filterData, // Dati filtrati
                        currentPage: page, // Pagina corrente
                        totalRows: totalElements, // Totale righe
                    },
                });
            
                // Mostra un messaggio di successo
                yield put({
                    type: openSnackbar.type,
                    payload: {
                        open: true,
                        message: "Filter applied successfully",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                    },
                });
            } else {
                // Gestisci errori del server
                console.error("Error applying filter:", response.data);
            
                // Dispatch error action
                yield put({ type: filterElementError.type });
            
                // Mostra un messaggio di errore
                yield put({
                    type: openSnackbar.type,
                    payload: {
                        open: true,
                        message: "Failed to apply filter",
                        variant: "alert",
                        alert: {
                            color: "error",
                        },
                    },
                });
            }
            
        } catch (error) {
            // Gestisci errori di rete o altri errori
            console.error("Error in filterElementSaga:", error);
            yield put({ type: filterElementError.type });

            // Mostra un messaggio di errore
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: "An error occurred while applying filter",
                    variant: "alert",
                    alert: {
                        color: "error",
                    },
                },
            });
        }
    });
}
*/


export default function* UserSaga() {
    yield all(
        [
            fork(getAllElementSaga),
            fork(saveElementSaga),
            fork(updateElementSaga),
            fork(deleteElementSaga),
            fork(getAllElementNotPageableSaga),
            /*
                        fork(filterElementSaga),
            */
        ],
    )
}